// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H15V7.5H13V4H4V13H7.5V15H2V2ZM9 9H22V22H9V9Z"}}]};

const CopyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'copy-filled',
    ref,
    icon: element,
  },
));

CopyFilledIcon.displayName = 'CopyFilledIcon';

export default CopyFilledIcon;
